<template>
<div class="align-self-center auto-spins-control">
    <button v-if="!autoSpinsLeft" id="auto-spins-popover" variant="primary" :disabled="controlsDisabled" @click="toggled">
        <fa-icon icon="layer-group"></fa-icon>
    </button>
    <button class="stop" v-else @click="stop">
        <fa-icon icon="stop"></fa-icon>
        <div class="left">
            {{autoSpinsLeft}}
        </div>
    </button>
    <b-popover ref="popover" target="auto-spins-popover" placement="top" trigers="blur" custom-class="auto-spins-popover">
        <div v-closable="{
            exclude: ['auto-spins-popover', 'popover-body', 'ignore-close'],
            handler: 'onClose'
        }">
            <span class="title pb-2">{{'auto_spins' | lang}}</span>
            <button class="mb-2 p-1" v-for="value in autoSpinValues" variant="primary" :key="`autSpin-${value}`" @click="start(value)" :disabled="controlsDisabled">{{value}}</button>
        </div>
        <div class="ignore-close">
            <label class="mb-0 ignore-close"><input type="checkbox" :checked="autoSpinsSettings.stopOnWin" @change="setStopOnWin"> {{ 'stop_on_win' | lang }}</label>
        </div>
    </b-popover>
</div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
    props: ['controlsDisabled'],
    data() {
        return {
            show: false,
            autoSpinValues: Config.auto_spin_values,
        }
    },
    methods: {
        ...mapMutations(['setAutoSpin', 'setAutoSpinSetting']),
        stop() {
            this.setAutoSpin(0);
            this.relayMethods.clickEvent('toogleAutoSpin');
        },
        start(value) {
            this.setAutoSpin(value);
            this.onClose();
            this.relayMethods.clickEvent('toogleAutoSpin');
        },
        onClose() {
            this.$refs.popover.$emit('close')
        },

        setStopOnWin(event) {
            this.setAutoSpinSetting({ name: 'stopOnWin', value: event.target.checked });
        },

        toggled() {
            this.relayMethods.clickEvent('toogleAutoSpin');
        }
    },
    computed: {
        ...mapState(['autoSpinsSettings', 'relayMethods']),

        autoSpinsLeft() {
            return this.$store.state.autoSpins;
        },
    },
}
</script>